<template>
  <div class="row align-items-center">
    <div class="col-sm-12 px-0">
      <div class="text-white" style="background-position: center center; background-repeat: no-repeat; background-size: cover; background-image: url(/img/levelup/bg_ark3.jpg);">
        <h1 class="py-4 text-center text-uppercase font-weight-bold">Deals</h1>
        <div class="container">
          <div class="row align-items-center">
            <div class="col text-center">
              <h2>Get A Discount Code In Your Inbox</h2>
              <h3>For Students (with a valid email address)</h3>
              <h4>Valid for groups of 3 or larger</h4>
            </div>
          </div>
          <div class="row align-items-center">
<!--
            <div class="col-md-6 px-0 text-center">
              <div class="" style="background-position: center center; background-repeat: no-repeat; background-size: cover; background-image: url(/img/levelup/blue-light.png); min-height: 400px; height: 100%;">
                <div style="background-color: rgba(0, 0, 0, 0.5); min-height: 400px;" class="w-100 h-100">
                  <div class="levelup-hero-pt"></div>
                  <h3 class="font-weight-bold mb-4 pt-2 text-uppercase">Blue Light Card</h3>
                  <p class="text-uppercase">Must be booked in-store</p>
                  <p class="text-uppercase">Not valid on Saturdays</p>
                  <div class="pb-4 text-center">
                    <button class="button-levelup" @click="discountType = 'NHS'; showDiscountDiv = true;">Get Your Discount</button>
                  </div>
                </div>
              </div>
            </div>
-->
            <div class="col-md-12 px-0 text-center">
              <div class="" style="background-position: center center; background-repeat: no-repeat; background-size: cover; background-image: url(/img/levelup/shrewsbury-college-logo.jpg); min-height: 400px; height: 100%;">
                <div style="background-color: rgba(0, 0, 0, 0.5); min-height: 400px;" class="w-100 h-100">
                  <div class="levelup-hero-pt"></div>
                  <h3 class="font-weight-bold mb-4 pt-2 text-uppercase text-shadow-highlight">Shrewsbury College</h3>
                  <p class="text-uppercase text-shadow-highlight">Must be booked in-store</p>
                  <p class="text-uppercase text-shadow-highlight">Not valid on Saturdays</p>
                  <div class="pb-4 text-center">
                    <button class="button-levelup" @click="discountType = 'STUDENT'; showDiscountDiv = true;">Get Your Discount</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pb-4">
          <h2 class="h1 py-4 text-center font-weight-bold">Discounts cannot be combined with other offers or special packages</h2>
        </div>
        <div class="container" v-if="showDiscountDiv">
          <div class="col-sm-12 px-0">
            <!-- <div v-if="$mq == 'sm' || $mq == 'xs'"> -->
            <div class="py-4">
              <div class="alert alert-red">
                <template v-if="showDiscountForm">
                  <h3 class="alert-heading">Please provide your details to obtain your {{ discountBlurb }}</h3>
                  <div class="input-group input-group-lg my-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Name</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      :class="nameError ? 'is-invalid' : ''"
                      placeholder="Your name"
                      v-model="name">
                      <div v-if="nameError" class="invalid-feedback alert alert-danger">
                        {{ nameError }}
                      </div>
                  </div>
                  <div class="input-group input-group-lg my-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Email</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      :class="emailError ? 'is-invalid' : ''"
                      :placeholder="discountType == 'STUDENT' ? 'Email must be ?@?.ac.uk' : 'Email must be ?@nhs.net'"
                      v-model="email">
                      <div v-if="emailError" class="invalid-feedback alert alert-danger">
                        {{ emailError }}
                      </div>
                  </div>
                  <div class="input-group input-group-lg my-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Number</span>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      :class="numberError ? 'is-invalid' : ''"
                      placeholder="Your Mobile (optional)"
                      v-model="number">
                      <div v-if="numberError" class="invalid-feedback alert alert-danger">
                        {{ numberError }}
                      </div>
                  </div>
                  <div class="form-group">
                    <div class="form-check checkboxdiv" style="padding-left:0;">
                      <label class="checkboxdiv-label-lg">
                        <input v-model="subscribe" type="checkbox">
                        <span class="cr">
                          <span class="cr-icon">✔</span>
                        </span>
                      </label>
                      <label class="form-check-label" for="form-subscribe" style="position: relative; top: -1.75rem; font-size: 1.25rem;">
                        <br>Subscribe to future updates and offers
                      </label>
                    </div>
                  </div>

                  <p class="mb-0">By filling in this form you will receive your discount code via email, you will receive a reminder 24 hours before expiry if the discount is not redeemed.</p>
                  <p class="mb-0">The discount will be valid for 7 days and can be used once.</p>
                  <p class="mb-0">Newsletters and special offers are announced by email a couple of times a year. You must tick the above box if you would also like to be informed of these.</p>

                  <div class="py-2">
                    <button type="submit" class="btn btn-lg btn-green" @click="submitForm">Submit</button>
                  </div>
                </template>
                <template v-else>
                  <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                      <div class="alert alert-green">
                        <span class="md-72 material-icons">email</span>
                        <h3 class="alert-heading">Your discount has been emailed to your supplied email address, you should get it nearly instantly.</h3>
                        <h3 class="alert-heading">Your discount code can be used on a booking or voucher purchase, and is valid for 7 days (all details of which are in your email).</h3>
                      </div>
                    </div>
                    <div class="col-sm-1"></div>
                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    studentPc: Number,
    nhsPc: Number,
  },

  data() {
    return {
      showDiscountDiv: false,
      showDiscountForm: true,
      discountType: null,

      name: null,
      email: null,
      number: null,
      subscribe: false,

      nameError: null,
      emailError: null,
      numberError: null,
    };
  },

  computed: {
    discountBlurb() {
      if (this.discountType && this.discountType == 'STUDENT') {
        return this.studentPc + '% student discount code to your @*.ac.uk email address.'
      } else if (this.discountType && this.discountType == 'NHS') {
        return this.studentPc + '% NHS discount code to your @nhs.net email address.'
      }

      return null;
    }

  },

  watch: {

  },

  methods: {
    validate() {
      if (this.name === null) {
        let error = 'You must enter your name';
        flash(error, 'danger');
        this.nameError = error;

        return false;
      }
      this.nameError = null;

      if (this.email === null) {
        let error = 'You must enter an email address';
        flash(error, 'danger');
        this.emailError = error;

        return false;
      }
      if (this.discountType == 'STUDENT' && this.email && ! this.email.includes('.ac.uk')) {
        let error= 'Your email address must have an .ac.uk suffix';
        flash(error, 'danger');
        this.emailError = error;

        return false;
      }
      if (this.discountType == 'NHS' && this.email && ! this.email.includes('@nhs.net')) {
        let error = 'Your email address must have an @nhs.net suffix';
        flash(error, 'danger');
        this.emailError = error;

        return false;
      }
      this.emailError = null;

      return true;
    },

    submitForm() {
      console.log('submitForm');

      if (this.validate() === true) {
        // axios
        let request = {
          name: this.name,
          email: this.email,
          number: this.number,
          subscribe: this.subscribe,
          type: this.discountType,
        }

        this.loading(true);

        axios.post(this.route('api.level-up.discount'), request)
          .then((response) => {
            console.log('axios back');
            console.log('response.data', response.data);
            console.log('response.status', response.status);

            if (response.status == 204) {
              this.showDiscountForm = false;
              flash('Your Discount Code has been emailed', 'success');
            } else {
              flash('Error generating Discount Code', 'error');
              console.log('submitForm', response.data);
              console.log('submitForm', response.status);
              console.log('submitForm', response.statusText);
            }

            this.loading(false);
          })
          .catch((error) => {
            flash('Error generating Discount Code.', 'danger');
            if (error.response) {
              if (error.response.status == 422) {
                // if HTTP_UNPROCESSABLE_ENTITY some validation error laravel or us
                console.log('submitForm:422', error.response.data);
              } else if (error.response.status == 409) {
                // else if HTTP_CONFLICT
                console.log('submitForm:409', error.response.data);
              } else if (error.response.status == 403) {
                // else if HTTP_FORBIDDEN on enough permissions
                console.log('submitForm:403', error.response.data);
              } else if (error.response.status == 401) {
                // else if HTTP_UNAUTHORIZED not authorized
                console.log('submitForm:401', error.response.data);
                window.location.reload();
              } else {
                console.log('submitForm: Response error', error.response.data, error.response.status, error.response.headers);
              }
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.error('submitForm: Request error', error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.error('submitForm: Error', error);
            }

            this.loading(false);
          }); // axios
      }
    }, //submitForm

  },
}
</script>
